import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {
  success = false;
  message = 'Unknown email! Please contact us at insidertradingalerts@yahoo.com';
  // tslint:disable-next-line: max-line-length
  imagePath = 'https://firebasestorage.googleapis.com/v0/b/insider-trading-alerts.appspot.com/o/license.png?alt=media&token=0537a40b-0b59-4e73-9e3b-9763478e2e7c';
  titleSuccess = 'Your payment was successful.';
  subTitleSuccess = 'You now have access to all features.';
  titleFail = 'Something went wrong...';
  subTitleFail;
  description;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.success = this.route.snapshot.queryParams.success === 'true';
    if (this.route.snapshot.queryParams.message) {
      this.message = this.route.snapshot.queryParams.message;
    }
    if (this.success) {
      this.description = 'We have sent an email to <em property="italic">' + this.message + '</em>' +
        `.<br>If you don't see it within 15 minutes, please look in your spam folder.<br>
        Copy the license key in the email and add it in the extension as shown in the image below and click Submit.
        Happy trading!`;
    } else {
      this.subTitleFail = 'Error: ' + this.message;
      this.description = `Please try again or contact your credit card provider.
      For further help, please contact insidertradingalerts@yahoo.com with your details, including the error above.`;
    }
  }

}
